/** Named router-outlet for create/edit surfaces over the board (board stays mounted). */
export const ENTITY_BOARD_DIALOG_OUTLET = 'dialog';
